module.exports = __webpack_public_path__ + "img/europe-transfers.bb65383a.jpg";